<div class="wrapper mb-5">
    <div class="row align-items-center m-0" style="padding: 10px;">
        <img class="p-2" src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Novo Condutor</span>
    </div>
    <div class="component-box container-fluid">
        <form class="col-12 m-0 p-0" [formGroup]="colaboradorFormGroup" #colaboradorForm="ngForm"
            (ngSubmit)="onSubmit(colaboradorFormGroup.value)">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12 text-left component-title pt-4">
                        Editar Condutor
                    </div>
                    <div class="col-12">
                        <div class="row m-0">
                            <div class="col-lg-6 col-md-6 col-sm-12 py-2 border-right">
                                <div class="row m-0">
                                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">

                                        <mat-form-field class="w-100">
                                            <mat-label class="label-required">Nome:</mat-label>
                                            <input matInput formControlName="nome" id="nome" type="text"
                                                autocomplete="off" [readonly]="kycValidated">

                                            <mat-error
                                                *ngIf="(form.nome.invalid && (form.nome.dirty || form.nome.touched)) && form.nome.errors.required">
                                                Nome é obrigatório!
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.nome.invalid && (form.nome.dirty || form.nome.touched)) && form.nome.errors.maxlength">
                                                Nome deve conter no máximo 100 caracteres.
                                            </mat-error>
                                            <mat-error class="mb-3"
                                                *ngIf="(form.nome.invalid && (form.nome.dirty || form.nome.touched)) && form.nome.errors.minlength">
                                                Nome deve conter no mínimo 3 caracteres.
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label class="label-required">Sobrenome</mat-label>
                                            <input matInput formControlName="sobrenome" id="sobrenome" type="text"
                                                autocomplete="off" [readonly]="kycValidated">

                                            <mat-error
                                                *ngIf="(form.sobrenome.invalid && (form.sobrenome.dirty || form.sobrenome.touched)) && form.sobrenome.errors.required">
                                                Sobrenome é obrigatório!
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.sobrenome.invalid && (form.sobrenome.dirty || form.sobrenome.touched)) && form.sobrenome.errors.maxlength">
                                                Sobrenome deve conter no máximo 100 caracteres.
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.sobrenome.invalid && (form.sobrenome.dirty || form.sobrenome.touched)) && form.sobrenome.errors.minlength">
                                                Sobrenome deve conter no mínimo 3 caracteres.
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="w-100 mb-3">
                                            <mat-label class="" [class.label-required]="documentReq">CPF
                                            </mat-label>
                                            <!-- <input [readOnly]="readOnlyDyn" [textMask]="{mask: MASKS.cpf.textMask}" formControlName="documento" id="documento" class="custom-input-outline" type="text" autocomplete="off"/> -->

                                            <input matInput formControlName="documento" id="documento"
                                                [textMask]="{mask: MASKS.cpf.textMask}" [readOnly]="readOnlyDyn"
                                                autocomplete="off">

                                            <mat-error
                                                *ngIf="(form.documento.invalid && (form.documento.dirty || form.documento.touched)) && form.documento.errors.required">
                                                CPF é obrigatório!
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.documento.invalid && (form.documento.dirty || form.documento.touched)) && form.documento.errors.cpf">
                                                CPF é inválido!
                                            </mat-error>
                                        </mat-form-field>

                                        <div class="custom-pr-5 mb-3" *ngIf="!isMobile">
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="input-container">
                                                        <label class="label-data"
                                                            [class.label-required]="birthDateReq">Data de
                                                            nascimento</label>
                                                        <div class="input-group">
                                                            <input formControlName="dataNascimento"
                                                                [readonly]="kycValidated" [locale]="'pt-br'" [options]="
                                                                            myDatePickerOptions
                                                                        " angular-mydatepicker
                                                                #dp="angular-mydatepicker"
                                                                class="form-control m-0 input-data"
                                                                name="dataNascimento" (keyup)="dateMask($event)"
                                                                [maxlength]="10" autocomplete="off" />
                                                            <button type="button"
                                                                class="btn input-group-append input-group-text p-0 calendar-btn"
                                                                (click)="dp.toggleCalendar()"
                                                                [disabled]="kycValidated"></button>
                                                        </div>
                                                    </div>
                                                    <div *ngIf="
                                                                    form.dataNascimento.invalid &&
                                                                    (form.dataNascimento.dirty ||
                                                                        form.dataNascimento.touched)
                                                                " class="text-danger">
                                                        <div *ngIf="form.dataNascimento?.errors?.required">
                                                            Data de nascimento é obrigatória
                                                        </div>
                                                        <div *ngIf="form.dataNascimento?.errors?.minimumAge">
                                                            O favorecido deve ter idade superior a {{minimumAge}} anos
                                                        </div>
                                                        <div *ngIf="form.dataNascimento?.errors?.lockDate">
                                                            Data de nascimento inválida
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- <mat-form-field class="w-100">
                                                    <mat-label class="" [class.label-required]="birthDateReq">
                                                        Data de nascimento</mat-label>
                                                    <input [formControl]="form.dataNascimento" matInput
                                                        [matDatepicker]="birthDate" autocomplete="off"  [readonly]="kycValidated"/>
                                                    <mat-datepicker-toggle matSuffix [for]="birthDate">
                                                    </mat-datepicker-toggle>
                                                    <mat-datepicker #birthDate></mat-datepicker>

                                                    <mat-error *ngIf="(form.dataNascimento.invalid && (form.dataNascimento.dirty || form.dataNascimento.touched)) && form.dataNascimento?.errors?.required">
                                                        Data de nascimento é obrigatória!
                                                    </mat-error>
                                                    <mat-error *ngIf="(form.dataNascimento.invalid && (form.dataNascimento.dirty || form.dataNascimento.touched)) && form.dataNascimento?.errors?.minimumAge">
                                                        O favorecido deve ter idade superior a {{minimumAge}} anos
                                                    </mat-error>
                                                    <mat-error *ngIf="(form.dataNascimento.invalid && (form.dataNascimento.dirty || form.dataNascimento.touched)) && form.dataNascimento?.errors?.lockDate">
                                                        Data de nascimento inválida
                                                    </mat-error>
                                                    <mat-error *ngIf="(form.dataNascimento.invalid && (form.dataNascimento.dirty || form.dataNascimento.touched)) && form.dataNascimento?.errors?.maximumAge">
                                                        O favorecido deve ter idade inferior a {{maxAge}} anos
                                                    </mat-error>
                                                </mat-form-field> -->

                                        <mat-form-field class="w-100">
                                            <mat-label class=""
                                                [class.label-required]="cadastroColaboradorTelefoneObrigatorio">
                                                Telefone
                                                Celular</mat-label>
                                            <input matInput formControlName="celular" id="celular" type="text"
                                                [textMask]="{mask: telefoneCelularMask}" autocomplete="off">

                                            <mat-error
                                                *ngIf="(form.celular.invalid && (form.celular.dirty || form.celular.touched)) && form.celular.errors.required">
                                                Telefone celular é obrigatória!
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.celular.invalid && (form.celular.dirty || form.celular.touched)) && form.celular.errors.celular">
                                                Telefone celular inválido
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.celular.invalid && (form.celular.dirty || form.celular.touched)) && form.celular.errors.isCellPhone">
                                                Telefone celular deve conter o dígito 9
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label class="label-required">CNH</mat-label>
                                            <input matInput formControlName="cnh" id="cnh" type="text"
                                                autocomplete="off" maxlength="11">
                                            <mat-error
                                                *ngIf="(form.cnh.invalid && (form.cnh.dirty || form.cnh.touched)) && (form.cnh.errors.maxlength || form.cnh.errors.minlength)">
                                                CNH deve conter no 11 caracteres.
                                            </mat-error>
                                        </mat-form-field>

                                        <!-- <mat-form-field appearance="fill">
                                                        <mat-label>Data de Validade (CNH)</mat-label>
                                                        <input matInput [matDatepicker]="cnhExpirationDate" formControlName="cnhExpirationDate" (dateChange)="getDate($event)">
                                                        <mat-datepicker-toggle matSuffix [for]="cnhExpirationDate"></mat-datepicker-toggle>
                                                        <mat-datepicker #cnhExpirationDate></mat-datepicker>
                                                    </mat-form-field> -->


                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="input-container">
                                                    <label class="label-data">Data de Validade (CNH)</label>
                                                    <div class="input-group">
                                                        <input formControlName="cnhDataExpiracao" [locale]="'pt-br'"
                                                            [options]="myDatePickerOptions2" angular-mydatepicker
                                                            #dp="angular-mydatepicker"
                                                            class="form-control m-0 input-data" name="cnhDataExpiracao"
                                                            (keyup)="dateMask($event)" [maxlength]="10"
                                                            autocomplete="off" />
                                                        <button type="button"
                                                            class="btn input-group-append input-group-text p-0 calendar-btn"
                                                            (click)="dp.toggleCalendar()"></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">

                                        <mat-form-field class="w-100">
                                            <mat-label class="" [class.label-required]="birthDateReq">
                                                Sexo</mat-label>
                                            <mat-select formControlName="sexo" id="sexo">
                                                <mat-option disabled value="">Selecione...</mat-option>
                                                <mat-option [value]="TipoSexo.Feminino">Feminino
                                                </mat-option>
                                                <mat-option [value]="TipoSexo.Masculino">Masculino
                                                </mat-option>
                                                <mat-option [value]="TipoSexo.Indefinido">Indefinido
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label class=""
                                                [class.label-required]="cadastroColaboradorEmailObrigatorio">
                                                E-mail
                                            </mat-label>
                                            <input matInput formControlName="email" id="email" type="email"
                                                autocomplete="off">

                                            <mat-error
                                                *ngIf="(form.email.invalid && (form.email.dirty || form.email.touched)) && form.email.errors.required">
                                                E-mail é obrigatório!
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.email.invalid && (form.email.dirty || form.email.touched)) && form.email.errors.maxlength">
                                                E-mail deve conter no máximo 100 caracteres.
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.email.invalid && (form.email.dirty || form.email.touched)) && form.email.errors.email">
                                                Formato de e-mail inválido!
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label class="" [class.label-required]="motherNameReq">
                                                Nome da mãe
                                            </mat-label>
                                            <input matInput formControlName="nomeMae" id="nomeMae" type="text"
                                                autocomplete="off" [readonly]="kycValidated">

                                            <mat-error
                                                *ngIf="(form.nomeMae.invalid && (form.nomeMae.dirty || form.nomeMae.touched)) && form.nomeMae.errors.maxlength">
                                                Nome deve conter no máximo 100 caracteres.
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.nomeMae.invalid && (form.nomeMae.dirty || form.nomeMae.touched)) && form.nomeMae.errors.minlength">
                                                Nome da mãe deve conter no mínimo 3 caracteres.
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.nomeMae.invalid && (form.nomeMae.dirty || form.nomeMae.touched)) && form.nomeMae.errors.required">
                                                Nome da mãe é obrigatório!
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label class="">Nome do Pai</mat-label>
                                            <input matInput formControlName="nomePai" id="nomePai" type="text"
                                                autocomplete="off">

                                            <mat-error
                                                *ngIf="(form.nomePai.invalid && (form.nomePai.dirty || form.nomePai.touched)) && form.nomePai.errors.maxlength">
                                                Nome deve conter no máximo 100 caracteres.
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.nomePai.invalid && (form.nomePai.dirty || form.nomePai.touched)) && form.nomePai.errors.minlength">
                                                Nome do pai
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="w-100">
                                            <mat-label class="">Nome do Cartão</mat-label>
                                            <input matInput formControlName="apelido" id="apelido" type="text"
                                                autocomplete="off" readonly>

                                            <mat-error
                                                *ngIf="(form.apelido.invalid && (form.apelido.dirty || form.apelido.touched)) && form.apelido.errors.maxlength">
                                                Nome do cartão deve conter no máximo 20 caracteres.
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.apelido.invalid && (form.apelido.dirty || form.apelido.touched)) && form.apelido.errors.minlength">
                                                Nome do cartão deve conter no mínimo 3 caracteres.
                                            </mat-error>
                                            <mat-error
                                                *ngIf="(form.apelido.invalid && (form.apelido.dirty || form.apelido.touched)) && form.apelido.errors.required">
                                                Nome do cartão é obrigatório!
                                            </mat-error>
                                        </mat-form-field>

                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 py-2 px-0 mt-4">
                                        <div class="row m-0">
                                            <div class="col-12">
                                                <mat-checkbox class="" formControlName="suspender" color="primary">
                                                    Suspender recarga</mat-checkbox>
                                            </div>
                                            <!-- <div class="col-6">
                                                        <div class="row">
                                                            <div class="col-sm-12">
                                                                <div class="input-container">
                                                                    <label class="label-data">Suspensão de</label>
                                                                    <div class="input-group">
                                                                        <input formControlName="suspensaoInicio" #suspensaoInicio [readonly]="!form.suspender.value" [locale]="'pt-br'" [options]="
                                                                                myDatePickerOptions2
                                                                            " angular-mydatepicker #dp2="angular-mydatepicker" class="form-control m-0 input-data" name="suspensaoInicio" (keyup)="dateMask($event)" [maxlength]="10" autocomplete="off"/>
                                                                        <button type="button" [disabled]="!form.suspender.value" class="btn input-group-append input-group-text p-0 calendar-btn" (click)="dp2.toggleCalendar()"></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-6">
                                                        <div class="row">
                                                            <div class="col-sm-12">
                                                                <div class="input-container">
                                                                    <label class="label-data">Até</label>
                                                                    <div class="input-group">
                                                                        <input formControlName="suspensaoFim" #suspensaoFim [readonly]="!form.suspender.value" [locale]="'pt-br'" [options]="
                                                                                myDatePickerOptions2
                                                                            " angular-mydatepicker #dp3="angular-mydatepicker" class="form-control m-0 input-data" name="suspensaoFim" (keyup)="dateMask($event)" [maxlength]="10" autocomplete="off"/>
                                                                        <button type="button" [disabled]="!form.suspender.value" class="btn input-group-append input-group-text p-0 calendar-btn" (click)="dp3.toggleCalendar()"></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p class="col-12 m-0 pt-2" *ngIf="colaborador?.suspensaoInicio && colaborador?.suspensaoFim">
                                                        Suspensão de {{  this.getDateTime(colaborador.suspensaoInicio) | date: "dd/MM/yyyy" }} até {{ this.getDateTime(colaborador.suspensaoFim) | date: "dd/MM/yyyy" }}
                                                    </p> -->
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-12 px-3">
                                <div class="accordion" id="accordionExample">
                                    <div class="card border-0">
                                        <div class="card-header bg-white mb-0" id="headingOne">
                                            <h2 class="mb-0">
                                                <button class="btn btn-block text-left panel-heading" type="button"
                                                    data-toggle="collapse" data-target="#collapseOne"
                                                    aria-expanded="true" aria-controls="collapseOne">
                                                    Informações da Empresa
                                                </button>
                                            </h2>
                                        </div>

                                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne">
                                            <div class="card-body p-2">

                                                <mat-form-field class="w-50 px-3">
                                                    <mat-label>{{ labelMatricula }}</mat-label>
                                                    <input matInput formControlName="matricula" type="text"
                                                        autocomplete="off">
                                                </mat-form-field>

                                                <mat-form-field class="w-50 px-3" *ngIf="mostrarColunaUnidade">
                                                    <mat-label class="" [class.label-required]="isUnidadeRequired">{{
                                                        labelUnidade }}</mat-label>
                                                    <mat-select formControlName="unidadeId" id="unidadeId">
                                                        <mat-option disabled value="">Selecione...
                                                        </mat-option>
                                                        <mat-option *ngFor="let itemUnidade of unidadesList"
                                                            [value]="itemUnidade.unidadeId">{{
                                                            itemUnidade.nome }}</mat-option>
                                                    </mat-select>
                                                    <mat-error
                                                        *ngIf="(form.unidadeId.invalid && (form.unidadeId.dirty || form.unidadeId.touched)) && form?.unidadeId?.errors?.required">
                                                        {{ labelUnidade }} é obrigatória!
                                                    </mat-error>
                                                </mat-form-field>

                                                <mat-form-field class="w-50 px-3" *ngIf="mostrarColunaCentroCusto">
                                                    <mat-label class="">{{ labelCentroCusto }}
                                                    </mat-label>
                                                    <mat-select formControlName="centroCustoId" id="centroCustoId">
                                                        <mat-option disabled value="">Selecione...
                                                        </mat-option>
                                                        <mat-option *ngFor="let itemCentroCusto of centrosCustosList"
                                                            [value]="itemCentroCusto.centroCustoId">{{
                                                            itemCentroCusto.nome }}</mat-option>
                                                    </mat-select>
                                                </mat-form-field>

                                                <mat-form-field class="w-50 px-3" *ngIf="mostrarColunaDepartamento">
                                                    <mat-label class="">{{ labelDepartamento }}
                                                    </mat-label>
                                                    <mat-select formControlName="departamentoId" id="departamentoId">
                                                        <mat-option disabled value="">Selecione...
                                                        </mat-option>
                                                        <mat-option *ngFor="let itemDepartamento of departamentosList"
                                                            [value]="itemDepartamento.departamentoId">{{
                                                            itemDepartamento.nome }}</mat-option>
                                                    </mat-select>
                                                </mat-form-field>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="card border-0">
                                        <div class="card-header bg-white mb-0" id="headingTwo">
                                            <h2 class="mb-0">
                                                <button class="btn  btn-block text-left collapsed" type="button"
                                                    data-toggle="collapse" data-target="#collapseTwo"
                                                    aria-expanded="false" aria-controls="collapseTwo" disabled>
                                                    Informações de Endereço
                                                </button>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo">
                                            <div class="card-body p-2">
                                                <mat-form-field class="w-50 px-3">
                                                    <mat-label [class.label-required]="addressReq">CEP</mat-label>
                                                    <input matInput formControlName="cep"
                                                        [textMask]="{mask: MASKS.cep.textMask}"
                                                        (blur)="getAddress(colaboradorFormGroup.get('cep').value)">

                                                    <mat-error
                                                        *ngIf="(form.cep.invalid && (form.cep.dirty || form.cep.touched)) && form.cep.errors.cep">
                                                        CEP inválido.
                                                    </mat-error>
                                                    <mat-error
                                                        *ngIf="(form.cep.invalid && (form.cep.dirty || form.cep.touched)) && form.cep.errors.required">
                                                        CEP é obrigatório!
                                                    </mat-error>
                                                </mat-form-field>

                                                <mat-form-field class="w-50 px-3">
                                                    <mat-label [class.label-required]="addressReq">Endereço</mat-label>
                                                    <input matInput formControlName="address">
                                                    <mat-error
                                                        *ngIf="(form.address.invalid && (form.address.dirty || form.address.touched)) && form.address.errors.required">
                                                        Endereço é obrigatório!
                                                    </mat-error>
                                                </mat-form-field>

                                                <mat-form-field class="w-50 px-3">
                                                    <mat-label [class.label-required]="addressReq">Número</mat-label>
                                                    <input onlyNumber matInput formControlName="number" maxlength="10"
                                                        (change)="semNumero(colaboradorFormGroup.get('number').value)">
                                                    <mat-error
                                                        *ngIf="(form.number.invalid && (form.number.dirty || form.number.touched)) && form.number.errors.required">
                                                        Número é obrigatório!
                                                    </mat-error>
                                                </mat-form-field>

                                                <mat-form-field class="w-50 px-3">
                                                    <mat-label>Complemento</mat-label>
                                                    <input formControlName="complement" matInput>
                                                </mat-form-field>

                                                <mat-form-field class="w-50 px-3">
                                                    <mat-label [class.label-required]="addressReq">Bairro</mat-label>
                                                    <input matInput formControlName="neighborhood">
                                                    <mat-error
                                                        *ngIf="(form.neighborhood.invalid && (form.neighborhood.dirty || form.neighborhood.touched)) && form.neighborhood.errors.required">
                                                        Bairro é obrigatório!
                                                    </mat-error>
                                                </mat-form-field>

                                                <mat-form-field class="w-50 px-3">
                                                    <mat-label [class.label-required]="addressReq">Cidade</mat-label>
                                                    <input matInput formControlName="city">
                                                    <mat-error
                                                        *ngIf="(form.city.invalid && (form.city.dirty)) && form.city.errors.required">
                                                        Cidade é obrigatório!
                                                    </mat-error>
                                                </mat-form-field>

                                                <mat-form-field class="w-50 px-3">
                                                    <mat-label [class.label-required]="addressReq">Estado</mat-label>
                                                    <input matInput formControlName="uf" maxlength="2">
                                                    <mat-error
                                                        *ngIf="(form.uf.invalid && (form.uf.dirty)) && form.uf.errors.required">
                                                        Estado é obrigatório!
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div *ngIf="item.collaboratorTypeId === 1 || item.collaboratorTypeId === 2" class="row button-container mt-4 mb-2" [ngClass]="{ 'btn-fixed': isMobile }">
                            <div class="col-12 text-left">
                                <p>
                                    <strong>* </strong>{{item.collaboratorType}}s são elegiviveis para uso do cartão Bankei
                                </p>
                            </div>
                        </div> -->
                <div class="row button-container mt-4 mb-2" [ngClass]="{ 'btn-fixed': isMobile }">
                    <div class="col-12 text-left">
                        <p>
                            Cadastrado por: {{ gestorCadastro }} em {{ dataCadastro | date: "dd/MM/yyyy"}}
                            <br>
                            <ng-container *ngIf="dataAlteracao != null">
                                Última edição por: {{ gestorAlteracao }} em {{ dataAlteracao | date: "dd/MM/yyyy"}}
                            </ng-container>
                        </p>
                    </div>
                </div>
                <div class="row button-container mt-3 mb-5" [ngClass]="{ 'btn-fixed': isMobile }">
                    <div class="col-12 text-right">
                        <button class="custom-button-fullbtn-back custom-button-previous" (click)="goToBack()">
                            Voltar
                        </button>

                        <button type="submit" class="custom-button-full">
                            Editar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>